import React, { useEffect, useCallback, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import YouTube from "react-native-youtube-iframe";

const YouTubePlayer = ({
    youTubeVideoId,
    youTubeStartTime,
    youTubeEndTime,
}) => {
    const navigation = useNavigation();
    const [playing, setPlaying] = useState(false);
    const [invisible, setInVisible] = useState(false);

    const onStateChange = useCallback(state => {
        if (state === "ended") {
            setPlaying(false);
        }
    }, []);

    useEffect(() => {
        return navigation.addListener("blur", () => {
            console.log("Navigation Blur");
            setPlaying(false);
            setInVisible(true);
        });
    }, [navigation]);

    if (invisible) {
        // remove player if navigating away
        return null;
    }

    let initialPlayerParams = {};
    if (youTubeStartTime || youTubeEndTime) {
        initialPlayerParams = {
            start: youTubeStartTime,
            end: youTubeEndTime,
        };
    }

    // opacity 0.99 fixes a crashing bug on Android related to hardware acceleration
    return (
        <YouTube
            videoId={youTubeVideoId}
            height={300}
            webViewStyle={{ alignSelf: "stretch", opacity: 0.99 }}
            play={playing}
            onChangeState={onStateChange}
            initialPlayerParams={{
                loop: false,
                controls: true,
                ...initialPlayerParams,
            }}
        />
    );
};

export default YouTubePlayer;
